/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { computed } from '@ember/object';
import ActionModel from 'cio/models/action';
import TemplateModel from 'cio/models/template';

interface PushActionArgs {
  action: ActionModel;
  disableOverlay: boolean;
  hasContent: boolean;
  disabled: boolean;
  template: TemplateModel | null;
  sanitizedBody: string;
  hasReadOnlyPermission: boolean;
}

export default class PushAction extends Component<PushActionArgs> {
  @computed('args.template.bodyJson')
  get pushActionPayload() {
    if (this.args.template == null) {
      return {};
    }

    return JSON.parse(this.args.template.bodyJson);
  }
}
